import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './Homepage.scss';
import HomepageBigPromise from './components/HomepageBigPromise';
import HomePageFAQ from './components/HomepageFAQ';
import HomepageIncentives from './components/HomepageIncentives';
import getLocalVehicles from '../../../functions/vehicle/getLocalVehicles';
import ShuffleFlatArray from '../../../utils/Helpers/ShuffleFlatArray';
import VehiclesCarousel from '../../../components/VehicleCarousel/VehicleCarousel';
import ChargingMap from '../LocationMap/ChargingMap';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import eRideIcon from '../../assets/images/icons/e-ride-icon.svg';
import { FormattedMessage } from 'react-intl';

const Homepage = ({
  homePageBannerImage,
  electricVehicles,
  incentives,
  chargingStations,
  userLocation,
  language,
  ip,
  uuid,
}) => {
  const [vehicles, setVehicles] = useState([]);
  const setElectricVehicles = () => {
    if (electricVehicles) setVehicles(ShuffleFlatArray(electricVehicles));
  };

  useEffect(() => {
    document.title = process.env.REACT_APP_PAGES_HOME_TITLE;
    setElectricVehicles();
  });

  const renderDetails =
    electricVehicles && incentives ? (
      <>
        <VehiclesCarousel electricVehicles={getLocalVehicles(vehicles)} />
        <HomePageFAQ />
        <HomepageIncentives language={language} />
      </>
    ) : (
      <section className="container">
        <LoadingSpinner />
      </section>
    );

  return (
    <>
      <HomepageBigPromise homePageBannerImage={homePageBannerImage} />
      {renderDetails}
      <div id="HomepageChargingStations">
        <ChargingMap language={language} />
      </div>
      <div className="bottom-cta-container">
        <div className="container">
          <div className="bottom-cta">
            <img src={eRideIcon} alt="icon" />
            <h3>
              <FormattedMessage
                id="erides.wantToRide"
                defaultMessage="Want to ride electric as well as drive? Check out the {link}."
                values={{
                  link: (
                    <a href="/e-ride">
                      <FormattedMessage
                        id="erides.wantToRide.link"
                        defaultMessage="E-Ride page"
                      />
                    </a>
                  ),
                }}
              />
            </h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default Homepage;

Homepage.propTypes = {
  homePageBannerImage: PropTypes.string,
  electricVehicles: PropTypes.array,
  incentives: PropTypes.array,
  ip: PropTypes.string,
  uuid: PropTypes.string,
};
